import React from 'react';
import ReactDOM from "react-dom";
import { QueryClientProvider } from "react-query";
import { BrowserRouter } from "react-router-dom";
import { Preflight, ThemeProvider } from "@xstyled/emotion";
import GlobalStyle from "./style/global";
import theme from "style/theme";
import { queryClient } from "./common/request";
import { Provider } from 'jotai';
import "./Fonts/Font.css";
// import "kakao-js-sdk";


import App from "./App";

function Root() {
  return (
    <Provider>
      <BrowserRouter>
        <QueryClientProvider client={queryClient}>
          <ThemeProvider theme={theme}>
            <GlobalStyle />
            <Preflight />
              <App />
          </ThemeProvider>
        </QueryClientProvider>
      </BrowserRouter>
    </Provider>
  );
}

ReactDOM.render(<Root />, document.getElementById("root"));
